import React, { FunctionComponent, useState } from 'react';
import { CardActions, Grid, IconButton, makeStyles, Paper, Theme } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import { FormSection } from '../../../store/modules/application/types';
import FormFieldDisplay from '../FormFieldDisplay';
import { ErrorState } from '../types';

type FormPanelProps = {
    formSection: FormSection;
    formData: Record<string, unknown>;
    formErrors: Record<string, ErrorState>;
    handleEdit: Function;
    handleInputChange: Function;
    handleSave: Function;
    handleCancel: Function;
    handleSelectedInspector?: Function;
};

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        padding: '35px 30px',
    },
    panelHeading: {
        color: theme.palette.primary.light,
        fontSize: '12px',
        marginBottom: '15px',
        fontWeight: 600,
    },
    pencilIcon: {
        justifyContent: 'right',
        textAlign: 'right',
        marginTop: '-20PX',
        cursor: 'pointer',
        color: '#c8c8c8',
    },
    editIcon: {
        float: 'right',
        padding: 0,
        display: 'inline-block',
    },
}));

const FormPanel: FunctionComponent<FormPanelProps> = (props) => {
    const {
        formSection,
        formData,
        formErrors,
        handleEdit,
        handleInputChange,
        handleSave,
        handleCancel,
        handleSelectedInspector,
    } = props;

    const classes = useStyles();
    const [readOnly, setReadOnly] = useState(true);

    const handleEditIcon = () => {
        handleEdit();
        setReadOnly(false);
    };

    const handleCloseIcon = () => {
        handleCancel();
        setReadOnly(true);
    };

    const handleCheckIcon = () => {
        handleSave();
        setReadOnly(false);
    };

    return (
        <Paper className={classes.paper}>
            <Grid container>
                <Grid item xs={6} sm={6} md={6} lg={6} className={classes.panelHeading}>
                    {formSection.name.toLocaleUpperCase()}{' '}
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} className={classes.pencilIcon}>
                    <CardActions className={classes.editIcon}>
                        {readOnly ? (
                            <IconButton title={`Edit ${formSection.name}`} onClick={handleEditIcon}>
                                <EditIcon />
                            </IconButton>
                        ) : (
                            <>
                                <IconButton title="Discard Changes" style={{ color: 'red' }} onClick={handleCloseIcon}>
                                    <CloseIcon />
                                </IconButton>

                                <IconButton title="Save Changes" style={{ color: 'green' }} onClick={handleCheckIcon}>
                                    <CheckIcon />
                                </IconButton>
                            </>
                        )}
                    </CardActions>
                </Grid>
            </Grid>
            {formSection.entries.map((entry) => {
                return (
                    <FormFieldDisplay
                        key={entry.field}
                        formField={entry}
                        value={formData[entry.field]}
                        error={formErrors[entry.field]}
                        readOnly={readOnly}
                        handleInputChange={handleInputChange}
                        formData={formData}
                        handleSelectedInspector={handleSelectedInspector}
                    />
                );
            })}
        </Paper>
    );
};

export default FormPanel;
